import React from "react";
import '../styles/Row.css';

const Row = (props) => {
    return (
        <div className="normal-row">
            {props.children}
        </div>
    )
}
export default Row;